import React, { useState } from "react";
import styles from "./ScheduleModal.module.css";
import proxy from "proxy";

const ScheduleModal = ({ onClose, projectId, setEvents }) => {
    const [date, setDate] = useState("");
    const [title, setTitle] = useState("");
    const [time, setTime] = useState("");

    const handleSave = async () => {
        if (!date || !title) {
            alert("All fields required");
            return;
        }

        const dateTime = new Date(`${date}T${time}:00`);

        try {
            const response = await fetch(`${proxy}/api/schedule`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: localStorage.getItem("organizationEmail"),
                    title,
                    projectId,
                    dateTime
                })
            })

            const status = response.status;
            const responseBody = await response.json();

            console.log("response:", responseBody);

            if (status === 201) {
                setEvents((prev) => [...prev, responseBody.data])
            }

            onClose();
        } catch (err) {
            console.error(err);
            alert("Error saving event");
        }
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <h3>Add Event</h3>

                <input
                    className={styles.input}
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                />

                <select
                    className={styles.input}
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                >
                    {Array.from({ length: 24 }, (_, i) => {
                        const hour = String(i).padStart(2, "0");
                        return (
                            <option key={hour} value={`${hour}:00`}>
                                {hour}:00
                            </option>
                        );
                    })}
                </select>

                <input
                    className={styles.input}
                    type="text"
                    placeholder="Event"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />

                <div className={styles.actions}>
                    <button className={styles.saveBtn} onClick={handleSave}>
                        Save
                    </button>
                    <button className={styles.cancelBtn} onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ScheduleModal;